export default {
  key: 'F',
  suffix: 'maj7b5',
  positions: [
    {
      frets: '102200',
      fingers: '102300'
    },
    {
      frets: 'xx3455',
      fingers: '001234'
    },
    {
      frets: 'x899ax',
      fingers: '012340'
    },
    {
      frets: 'dceecc',
      fingers: '213411',
      barres: 12,
      capo: true
    }
  ]
};
